import moment from 'moment';

export const getSelectedDateTime = (selectedDate: string, selectedTime: string) => {
    return moment(selectedDate)
        .hour(moment(selectedTime).hour())
        .minute(moment(selectedTime).minute())
        .toDate();
};
